module.exports = __webpack_public_path__ + "static/icon_PDF-ab28a9d201436ac42221d7018894918b.png";